export default __webpack_public_path__ + "static/media/device_controls.a93d56a0.svg";